import {Form} from "react-bootstrap";
import React from "react";
import * as PropTypes from "prop-types";

DateField.propTypes = {
    valid: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.any,
    readonly: PropTypes.bool
};

export function DateField(props) {
    return <Form.Group>
        <Form.Label><strong>Data</strong></Form.Label>
        <Form.Control
                      className={props.valid ? "": "is-invalid"} onChange={props.onChange}
                      name="date"
                      disabled={props.readonly}
                      value={props.value}
                      type="date"
        />
    </Form.Group>;
}

